module.exports = __webpack_public_path__ + "static/media/6-solution-0.f213820b.mp3";